var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.911,
    height: 34.78,
    viewBox: "0 0 34.911 34.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "linkedin",
    d: "M59.467.724H32.526a3.987,3.987,0,0,0-3.985,3.988V31.517A3.987,3.987,0,0,0,32.526,35.5h26.94a3.987,3.987,0,0,0,3.985-3.988V4.712A3.987,3.987,0,0,0,59.467.724M39.606,29.608H34.833V14.273h4.773ZM37.22,12.174A2.763,2.763,0,1,1,39.985,9.41a2.764,2.764,0,0,1-2.764,2.764M57.467,29.608H52.7V22.151c0-1.778-.036-4.067-2.48-4.067-2.482,0-2.861,1.936-2.861,3.936v7.587H42.6V14.273h4.57v2.094h.065a5.015,5.015,0,0,1,4.513-2.478c4.825,0,5.718,3.177,5.718,7.307Z",
    transform: "translate(-28.541 -0.724)",
    fill: "#2ca17f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.8aaaf653f03f2f53cef97411578f00cb.svg";
export { ForwardRef as ReactComponent };